import { DataBean } from "../DataBean";

export class DocumentsByCash extends DataBean {



    public async getDocumentsByCashReimbursement(idCashReimbursement:any,cashReimbursementDate:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDocumentsByCashReimbursement_Number_java.util.Date", [idCashReimbursement,cashReimbursementDate]);
    }
    
}